import React from "react";
import { useFormattedMsg } from "src/hooks/useFormatMsg";
import { X2yBasic } from "../../X2y";
import NoFooterModal from "../NoFooterModal";

type Props = {
  templateId: number;
  isOpen: boolean;
  toggleModal(): void;
};

const Templates2RolesModal = ({ templateId, isOpen, toggleModal }: Props) => {
  const title = useFormattedMsg("roles.add_roles");

  if (!isOpen) return null;

  return (
    <NoFooterModal title={title} isOpen={isOpen} toggle={toggleModal}>
      <X2yBasic
        controller="templates2Roles"
        xIdOrIds={templateId}
        onSaveCallback={toggleModal}
      />
    </NoFooterModal>
  );
};

export default Templates2RolesModal;
